/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccessRight } from './AccessRight';
import {
    AccessRightFromJSON,
    AccessRightFromJSONTyped,
    AccessRightToJSON,
} from './AccessRight';
import type { ReceiveFilter } from './ReceiveFilter';
import {
    ReceiveFilterFromJSON,
    ReceiveFilterFromJSONTyped,
    ReceiveFilterToJSON,
} from './ReceiveFilter';
import type { TransmitFilter } from './TransmitFilter';
import {
    TransmitFilterFromJSON,
    TransmitFilterFromJSONTyped,
    TransmitFilterToJSON,
} from './TransmitFilter';
import type { UserSetting } from './UserSetting';
import {
    UserSettingFromJSON,
    UserSettingFromJSONTyped,
    UserSettingToJSON,
} from './UserSetting';

/**
 * 
 * @export
 * @interface GroupDefinition
 */
export interface GroupDefinition {
    /**
     * The UID of the group
     * @type {string}
     * @memberof GroupDefinition
     */
    uid?: string;
    /**
     * 
     * @type {ReceiveFilter}
     * @memberof GroupDefinition
     */
    receiveFilter?: ReceiveFilter;
    /**
     * 
     * @type {TransmitFilter}
     * @memberof GroupDefinition
     */
    transmitFilter?: TransmitFilter;
    /**
     * 
     * @type {AccessRight}
     * @memberof GroupDefinition
     */
    accessRights?: AccessRight;
    /**
     * 
     * @type {UserSetting}
     * @memberof GroupDefinition
     */
    settings?: UserSetting;
}

/**
 * Check if a given object implements the GroupDefinition interface.
 */
export function instanceOfGroupDefinition(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GroupDefinitionFromJSON(json: any): GroupDefinition {
    return GroupDefinitionFromJSONTyped(json, false);
}

export function GroupDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupDefinition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uid': !exists(json, 'uid') ? undefined : json['uid'],
        'receiveFilter': !exists(json, 'receive_filter') ? undefined : ReceiveFilterFromJSON(json['receive_filter']),
        'transmitFilter': !exists(json, 'transmit_filter') ? undefined : TransmitFilterFromJSON(json['transmit_filter']),
        'accessRights': !exists(json, 'access_rights') ? undefined : AccessRightFromJSON(json['access_rights']),
        'settings': !exists(json, 'settings') ? undefined : UserSettingFromJSON(json['settings']),
    };
}

export function GroupDefinitionToJSON(value?: GroupDefinition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uid': value.uid,
        'receive_filter': ReceiveFilterToJSON(value.receiveFilter),
        'transmit_filter': TransmitFilterToJSON(value.transmitFilter),
        'access_rights': AccessRightToJSON(value.accessRights),
        'settings': UserSettingToJSON(value.settings),
    };
}

